import { combineReducers } from "@reduxjs/toolkit";
import UserSlice from "./userSlice";
const Slices = combineReducers({
  User: UserSlice,
});
export default Slices;
